module.exports = __webpack_public_path__ + "static/media/26UNRWA14.3be4b4cf.jpg";